import React, { useState } from 'react';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
export function OrderBumpSection() {
  const [isOpen, setIsOpen] = useState(false);
  return <section className="pt-8 pb-12 px-5" data-id="element-193">
      <div className="max-w-lg mx-auto" data-id="element-194">
        <div className="rounded-2xl border-2 border-dashed overflow-hidden relative flex flex-col" style={{
        borderColor: '#94A3B8',
        backgroundColor: '#FFFBEB'
      }} data-id="element-195">
          {/* One-Time Offer Badge */}
          <div className="absolute top-3 right-3 z-20" data-id="element-196">
            <span className="bg-red-600 text-white text-[11px] font-bold px-3 py-1 rounded-full shadow-md uppercase tracking-wide" data-id="element-197">
              Oferta única
            </span>
          </div>

          {/* Large Product Image — fills width */}
          <div className="w-full flex justify-center bg-gradient-to-b from-white/60 to-transparent pt-6 pb-2 px-8" data-id="element-198">
            <img src="https://cdn.magicpatterns.com/uploads/cTPvw8gDB2Ex84DUY2cbPc/nuevobump.png" alt="El Código del Silencio" className="w-full max-w-[280px] h-auto drop-shadow-[0_12px_35px_rgba(0,0,0,0.2)]" data-id="element-199" />
          </div>

          {/* Content */}
          <div className="px-6 pb-6 pt-4" data-id="element-200">
            {/* Headline */}
            <h3 className="text-lg font-extrabold text-charcoal leading-tight mb-3 text-center" data-id="element-201">
              ✨ ÚLTIMA OPORTUNIDAD: Evita destrozos cuando no estés
            </h3>

            {/* Description */}
            <p className="text-charcoal/70 text-[15px] leading-relaxed mb-5 text-center" data-id="element-202">
              Añade{' '}
              <strong className="text-charcoal" data-id="element-203">EL CÓDIGO DEL SILENCIO</strong>{' '}
              ahora por solo <strong className="text-charcoal" data-id="element-204">4,90€</strong>{' '}
              <span className="text-charcoal/40 line-through text-sm" data-id="element-205">
                (Antes 27€)
              </span>
              . No dejes que el progreso del paseo se pierda al cerrar la puerta
              de casa.
            </p>

            {/* Benefit Bullets */}
            <div className="space-y-2.5 mb-6" data-id="element-206">
              <div className="flex items-start gap-2.5" data-id="element-207">
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-208" />
                <span className="text-charcoal/80 text-sm" data-id="element-209">
                  Frena ladridos y quejas de los vecinos de inmediato.
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-210">
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-211" />
                <span className="text-charcoal/80 text-sm" data-id="element-212">
                  Protege tus muebles y zapatos de la ansiedad por separación.
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-213">
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-214" />
                <span className="text-charcoal/80 text-sm" data-id="element-215">
                  Vuelve a casa tranquilo, sabiendo que él está en calma total.
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <button className="w-full text-white font-bold text-base py-4 rounded-full shadow-[0_4px_20px_rgba(34,197,94,0.35)] flex items-center justify-center gap-2 transition-all active:scale-[0.98]" style={{
            backgroundColor: '#22C55E'
          }} data-id="element-216">
              SÍ, AÑADIR AL PEDIDO (+4,90€)
            </button>

            {/* Footer text */}
            <p className="text-charcoal/40 text-xs italic text-center mt-3" data-id="element-217">
              Acceso inmediato tras el pago. Oferta única e irrepetible.
            </p>

            {/* Accordion */}
            <div className="mt-5 pt-4 border-t border-charcoal/10" data-id="element-218">
              <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between text-left focus:outline-none group" data-id="element-219">
                <span className="text-sm font-semibold text-charcoal/60 group-hover:text-charcoal transition-colors" data-id="element-220">
                  ¿Cómo protege mi hogar?
                </span>
                <ChevronDown className={`w-4 h-4 text-charcoal/40 transition-transform duration-300 ${isOpen ? 'rotate-180 text-charcoal' : ''}`} data-id="element-221" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-222">
                <div className="p-4 rounded-xl bg-charcoal/5 border border-charcoal/10 space-y-3 text-sm text-charcoal/70 text-left" data-id="element-223">
                  <p data-id="element-224">
                    El manual definitivo para eliminar la Ansiedad por
                    Separación antes de que se convierta en un problema legal o
                    de convivencia.
                  </p>
                  <p data-id="element-225">
                    <strong className="text-charcoal" data-id="element-226">
                      El Ritual de Salida 'Sordo':
                    </strong>{' '}
                    Cómo romper la asociación de las llaves y zapatos con el
                    pánico.
                  </p>
                  <p data-id="element-227">
                    <strong className="text-charcoal" data-id="element-228">Cero Destrozos:</strong>{' '}
                    La técnica de la 'Habitación Segura' para que tu sofá y
                    puertas sobrevivan a tu ausencia.
                  </p>
                  <p data-id="element-229">
                    <strong className="text-charcoal" data-id="element-230">
                      Monitorización 2026:
                    </strong>{' '}
                    Cómo usar tecnología gratuita para saber si tu perro está
                    tranquilo en tiempo real.
                  </p>
                  <p data-id="element-231">
                    <strong className="text-charcoal" data-id="element-232">Resultado:</strong> Sal de
                    casa con la tranquilidad de que tu perro está en silencio y
                    relajado.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}